import React, { useEffect, useRef } from "react";
import { PerlinHearts } from "./PerlinHearts";
import { useApp } from "../../contexts/AppContext";
import useResizeObserver from "@react-hook/resize-observer";

function CanvasHearts() {
  const {
    state: { blurBackground },
  } = useApp();

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const perlinHeartsRef = useRef<PerlinHearts | null>(null);

  useResizeObserver(canvasRef, (entry) => {
    if (!perlinHeartsRef.current) return;

    perlinHeartsRef.current.resize();
  });

  useEffect(() => {
    if (!canvasRef.current) return;
    perlinHeartsRef.current = new PerlinHearts(canvasRef.current);

    return () => {
      perlinHeartsRef.current?.destroy();
    };
  }, [canvasRef]);

  return (
    <div className="fixed left-0 top-0 right-0 bottom-0">
      <canvas ref={canvasRef} className="w-full h-full" />
      <div
        className={`fixed left-0 top-0 right-0 bottom-0 transition-backdrop ease-in-out duration-1000
          ${blurBackground ? "backdrop-blur-lg" : "backdrop-blur-0"}`}
      />
    </div>
  );
}

export default CanvasHearts;
